import { render, staticRenderFns } from "./DepositStatementList.vue?vue&type=template&id=352d69ec&scoped=true&lang=pug&"
import script from "./DepositStatementList.vue?vue&type=script&lang=js&"
export * from "./DepositStatementList.vue?vue&type=script&lang=js&"
import style0 from "./DepositStatementList.vue?vue&type=style&index=0&id=352d69ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d69ec",
  null
  
)

/* custom blocks */
import block0 from "./DepositStatementList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports